const convertBookToRIS = (item, id) => {
  let result = `\nTY\t-\tBOOK`;
  if (item.title)
    result += `\nST\t-\t${item.title}\nT1\t-\t${item.title}\nT2\t-\t${item.title}`;
  if (item.publisher)
    result += `\nPB\t-\t${item.publisher}`;
  if (item.author) {
    for (let i = 0; i < item.author.length; i++) {
      let author = '';
      if (item.author[i].literal)
        author = item.author[i].literal
      else
        author = item.author[i].given + ' ' + item.author[i].family
      result += `\nA${i + 1}\t-\t${author}`
    }
  }
  if (item.editor) {
    for (let i = 0; i < item.editor.length; i++) {
      let editor = '';
      if (item.editor[i].literal)
        editor = item.editor[i].literal
      else
        editor = item.editor[i].given + ' ' + item.editor[i].family
      result += `\nED\t-\t${editor}`
    }
  }
  if (item.issued) {
    result += `\nDA\t-\t${item.issued['date-parts'][0][0]}`;
  }
  if (item.voulme) {
    result += `\nDA\t-\t${item.voulme}`;
  }
  if (item.edition) {
    result += `\nET\t-\t${item.edition}`;
  }
  result += '\nER\t-\t';
  return result;
}
const convertArticleToRIS = (item, id) => {
  let result = `\nTY\t-\tMGZN`;
  if (item.title)
    result += `\nST\t-\t${item.title}\nT1\t-\t${item.title}\nT2\t-\t${item.title}`;
  if (item.publisher)
    result += `\nPB\t-\t${item.publisher}`;
  if (item.author) {
    for (let i = 0; i < item.author.length; i++) {
      let author = '';
      if (item.author[i].literal)
        author = item.author[i].literal
      else
        author = item.author[i].given + ' ' + item.author[i].family
      result += `\nA${i + 1}\t-\t${author}`
    }
  }
  if (item.editor) {
    for (let i = 0; i < item.editor.length; i++) {
      let editor = '';
      if (item.editor[i].literal)
        editor = item.editor[i].literal
      else
        editor = item.editor[i].given + ' ' + item.editor[i].family
      result += `\nED\t-\t${editor}`
    }
  }
  if (item.issued) {
    result += `\nDA\t-\t${item.issued['date-parts'][0][0]}`;
  }
  if (item.voulme) {
    result += `\nDA\t-\t${item.voulme}`;
  }
  if (item.edition) {
    result += `\nET\t-\t${item.edition}`;
  }
  result += '\nER\t-\t';
  return result;
}
const convertThesisToRIS = (item, id) => {
  let result = `\nTY\t-\tMGZN`;
  if (item.title)
    result += `\nST\t-\t${item.title}\nT1\t-\t${item.title}\nT2\t-\t${item.title}`;
  if (item.publisher)
    result += `\nPB\t-\t${item.publisher}`;
  if (item.author) {
    for (let i = 0; i < item.author.length; i++) {
      let author = '';
      if (item.author[i].literal)
        author = item.author[i].literal
      else
        author = item.author[i].given + ' ' + item.author[i].family
      result += `\nA${i + 1}\t-\t${author}`
    }
  }
  if (item.editor) {
    for (let i = 0; i < item.editor.length; i++) {
      let editor = '';
      if (item.editor[i].literal)
        editor = item.editor[i].literal
      else
        editor = item.editor[i].given + ' ' + item.editor[i].family
      result += `\nED\t-\t${editor}`
    }
  }
  if (item.issued) {
    result += `\nDA\t-\t${item.issued['date-parts'][0][0]}`;
  }
  if (item.voulme) {
    result += `\nDA\t-\t${item.voulme}`;
  }
  if (item.edition) {
    result += `\nET\t-\t${item.edition}`;
  }
  result += '\nER\t-\t';
  return result;
}

const convertCslToRIS = (data) => {
  let result = '';
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    switch (item.type) {
      case 'book':
        result += convertBookToRIS(item, i);
        break;
      case 'article':
      case 'paper-conference':
        result += convertArticleToRIS(item, i);
        break;
      case 'thesis':
        result += convertThesisToRIS(item, i);
        break;
      default:
        break;
    }
  }
  return result;
}
const downloadRIS = (data, filename) => {
  const bib = convertCslToRIS(data);
  const blob = new Blob(['\ufeff', bib], {
    type: 'application/x-research-info-systems'
  });

  // Specify link url
  var url = 'data:application/x-research-info-systems;charset=utf-8,' + encodeURIComponent(bib);

  // Specify file name
  filename = filename ? filename + '.bib' : 'document.bib';

  // Create download link element
  var downloadLink = document.createElement("a");

  document.body.appendChild(downloadLink);

  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // Create a link to the file
    downloadLink.href = url;
    // Setting the file name
    downloadLink.download = filename;
    //triggering the function
    downloadLink.click();
  }
  document.body.removeChild(downloadLink);
}
module.exports = {
  convertCslToRIS,
  downloadRIS,
}